import { render, staticRenderFns } from "./AccessibilitySearchForm.vue?vue&type=template&id=20aa86a7&scoped=true"
import script from "./AccessibilitySearchForm.vue?vue&type=script&lang=js"
export * from "./AccessibilitySearchForm.vue?vue&type=script&lang=js"
import "./AccessibilitySearchForm.vue?vue&type=style&index=0&id=20aa86a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa86a7",
  null
  
)

export default component.exports